@if (!input.textContent) {
  <div class="{{ placeholderClass }}">
    <ng-container *ngTemplateOutlet="getPlaceholderTemplate()"></ng-container>
  </div>
}

<div
  #input
  class="{{ editableClass }}"
  [attr.contentEditable]="editable.toString()"
  (focusout)="focusOut($event)"
  (focusin)="focusIn($event)"
  (keydown)="keyDown($event)"
  (keyup)="keyUp($event)"
  (paste)="paste($event)"
></div>

<ng-template #portal="cdkPortal" cdk-portal>
  <div
    data-test-id="mentioning-popup"
    [class.invisible]="!isPopupOpen || !displayedUsers?.length"
    [id]="popupId"
    [style.min-width.px]="popupWidth"
    [style.max-width.px]="popupWidth"
    [class]="mentioningPopupClass + ' p-0'"
  >
    @if (displayedUsers?.length) {
      @for (user of displayedUsers; track user.id; let indx = $index) {
        <div
          #personWrapper
          class="option-wrapper"
          [class.sticky-option]="stickyOptions.includes(user.name)"
          [style.top.px]="stickyOptions.includes(user.name) ? stickyOptions.indexOf(user.name) * 38 : null"
          (click)="selectPerson(indx)"
        >
          <ng-container
            *ngTemplateOutlet="
              optionTemplate || defaultOptionTemplate;
              context: { user: user, isFocused: indx === focusedUserIndex }
            "
          ></ng-container>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #defaultOptionTemplate let-isFocused="isFocused" let-user="user">
  <div class="user-item" [class.focused]="isFocused">
    {{ user.name }}
  </div>
</ng-template>

<ng-template #stringPlaceholder>
  {{ placeholder }}
</ng-template>
